import React from 'react';

const trackerContent = `# Project Tracker: Strategic Action Plan

## Phase 1: Build a Public "Expertise & Compliance" Knowledge Hub
- Status: Pending

## Phase 2: Establish Unmistakable E-E-A-T (Author Credentials)
- Status: Pending

## Phase 3: Create Public, Interactive Client Problem-Solving Tools
- Status: In Progress
- Notes: Currently building backend generator and Super Admin dashboard integration for resource management.

## Phase 4: Implement AI-Friendly Structured Data (JSON-LD)
- Status: Pending

## Phase 5: Publish Real Operator Case Studies & Verified Metrics
- Status: Pending

## Phase 6: Address Functionality Gaps
- Status: Pending
- Items:
  - API Integration (POS & Payroll)
  - Handling of service tips
  - Handling of merchant fees
  - Wrapping in a compliance package

## Phase 7: Strategic & Operational Enterprise Scaling
- Status: Pending
- Items:
  - Automated Notification & Alerting Engine
  - Advanced Reporting & Automated Deliverables
  - Multi-Unit/Enterprise Hierarchies
  - Self-Service Onboarding & Configuration`;

export const ProjectTracker: React.FC = () => {
  return (
    <div className="bg-white p-8 rounded-[2rem] border border-gray-100 shadow-sm">
      <h2 className="text-xl font-black text-gray-900 uppercase italic mb-6">Strategic Action Plan</h2>
      <div className="prose prose-sm max-w-none text-gray-700">
        <pre className="whitespace-pre-wrap font-sans text-sm leading-relaxed">{trackerContent}</pre>
      </div>
    </div>
  );
};
